/* import __COLOCATED_TEMPLATE__ from './fly-tooltip.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { htmlSafe } from '@ember/template';
import { guidFor } from '@ember/object/internals';
// @ts-ignore: "ember-get-config" is not typed
import config from 'ember-get-config';
let FlyTooltip = (_class = class FlyTooltip extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "isOpen", _descriptor, this);
    _initializerDefineProperty(this, "arrowStyle", _descriptor2, this);
    _initializerDefineProperty(this, "triggerElement", _descriptor3, this);
    this.isOpen = this.args.isOpen ?? false;
    this.arrowStyle = this.args.arrowStyle ?? null;
  }
  get allowOpen() {
    return this.args.allowOpen ?? true;
  }
  get guid() {
    return `tooltip-${guidFor(this)}`;
  }
  get truncate() {
    return this.args.truncate ?? false;
  }
  get latency() {
    return this.args.latency ?? config?.['fly-components']?.tooltipLatency;
  }
  get containerId() {
    return this.args.containerId ?? 'fly-tooltips';
  }
  get direction() {
    return this.args.direction ?? 'bottom';
  }
  didInsertTrigger(element) {
    this.triggerElement = element;
  }
  findAnchor() {
    return this.triggerElement;
  }
  open() {
    debounce(this, this.setIsOpen, true, this.latency);
  }
  close() {
    debounce(this, this.setIsOpen, false, this.latency);
  }
  setIsOpen(isOpen) {
    if (this.isDestroying || this.isDestroyed) {
      return;
    }
    if (isOpen && !this.allowOpen) {
      return;
    }
    this.isOpen = isOpen;
    if (!isOpen) {
      this.arrowStyle = null;
    }
  }
  onEdgeOffset(alignment, triggerWidth) {
    if (alignment === 'left') {
      this.arrowStyle = htmlSafe(`left: ${triggerWidth / 2}px;`);
    }
    if (alignment === 'right') {
      this.arrowStyle = htmlSafe(`left: calc(100% - ${triggerWidth / 2}px);`);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "arrowStyle", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "triggerElement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "didInsertTrigger", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsertTrigger"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "findAnchor", [action], Object.getOwnPropertyDescriptor(_class.prototype, "findAnchor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "open", [action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEdgeOffset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onEdgeOffset"), _class.prototype)), _class);
export { FlyTooltip as default };